import { render, staticRenderFns } from "./InfoOne.vue?vue&type=template&id=1a4f120d&scoped=true&"
import script from "./InfoOne.vue?vue&type=script&lang=js&"
export * from "./InfoOne.vue?vue&type=script&lang=js&"
import style0 from "./InfoOne.vue?vue&type=style&index=0&id=1a4f120d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4f120d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4f120d')) {
      api.createRecord('1a4f120d', component.options)
    } else {
      api.reload('1a4f120d', component.options)
    }
    module.hot.accept("./InfoOne.vue?vue&type=template&id=1a4f120d&scoped=true&", function () {
      api.rerender('1a4f120d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/info-tabs/InfoOne.vue"
export default component.exports